const { weekDaySelected, convertFromUTC, isClientSide, convertFromLocal } = require('./utils')

function isInside (_tripStart, _tripEnd, userData) {
  const tripStart = new Date(_tripStart)
  const tripEnd = new Date(_tripEnd)

  if (weekDaySelected(tripStart, userData.weekDays)) {
    const timeWindowStartLocal = new Date(convertFromUTC(_tripStart, userData.user.attributes.timezone).toISOString().split('T')[0] + ' ' + userData.dayHours.startTime)
    const timeWindowEndLocal = new Date(convertFromUTC(_tripEnd, userData.user.attributes.timezone).toISOString().split('T')[0] + ' ' + userData.dayHours.endTime)

    const timeWindowStartUTC = isClientSide() ? timeWindowStartLocal : convertFromLocal(timeWindowStartLocal, userData.user.attributes.timezone)
    const timeWindowEndUTC = isClientSide() ? timeWindowEndLocal : convertFromLocal(timeWindowEndLocal, userData.user.attributes.timezone)

    if (timeWindowStartUTC.getTime() > timeWindowEndUTC.getTime()) {
      const startDatePreviousDay = new Date(timeWindowStartUTC)
      startDatePreviousDay.setDate(timeWindowStartUTC.getDate() - 1)
      const endDateNextDay = new Date(timeWindowEndUTC)
      endDateNextDay.setDate(timeWindowEndUTC.getDate() + 1)

      return (tripStart.getTime() > startDatePreviousDay.getTime() && tripEnd.getTime() < timeWindowEndUTC.getTime()) ||
          (tripStart.getTime() > timeWindowStartUTC.getTime() && tripEnd.getTime() < endDateNextDay.getTime())
    }
    // Trips inside time period
    return tripStart.getTime() > timeWindowStartUTC.getTime() && tripEnd.getTime() < timeWindowEndUTC.getTime()
  }

  return false
}

exports.isInside = isInside
